import guidedConversationConstants from '../../../../platform_common_constants/guided_conversation_constants.json';

const guidedConversationsWidgetReducers = {
  setGuidedConversationsWidgetData: (state, action) => {
    state.guidedConversationsWidgetData = action.payload;
  },
  reloadGuidedConversationsWidget: (state, action) => {
    if (state.guidedConversationsWidgetData) {
      state.guidedConversationsWidgetData.reloadWidget = action.payload;
    }
  },
  setGuidedConversationsApplicable: (state, action) => {
    state.data.guidedConversationsApplicable = action.payload;
  },
  updateGuidedConversationsGuidesData: (state, action) => {
    if (state.guidedConversationsWidgetData) {
      state.guidedConversationsWidgetData.guidesData = action.payload;
    }
  },
  updateGuidedConversationsGuidesDataByTab: (state, action) => {
    if (state.guidedConversationsWidgetData) {
      if (!state.guidedConversationsWidgetData.guidesDataByTab) {
        state.guidedConversationsWidgetData.guidesDataByTab = {};
      }
      const { tabId, data } = action.payload;
      state.guidedConversationsWidgetData.guidesDataByTab[tabId] = data;
    }
  },
  clearGuidedConversationsGuidesDataByTab: (state) => {
    if (state.guidedConversationsWidgetData) {
      state.guidedConversationsWidgetData.guidesDataByTab = {};
    }
  },
  updateGuidedConversationsSelectedTabId: (state, action) => {
    if (state.guidedConversationsWidgetData?.tabsData) {
      state.guidedConversationsWidgetData.tabsData.selectedTabId = action.payload;
    }
  },
  setGuidedConversationsGuideCardLoading: (state, action) => {
    if (state.guidedConversationsWidgetData) {
      state.guidedConversationsWidgetData.guideCardLoading = action.payload;
    }
  },
  setLoaderForGuidedConversationsWidget: (state, action) => {
    if (state.guidedConversationsWidgetData) {
      state.guidedConversationsWidgetData.setWidgetLoader = action.payload;
    }
  },
  setGuidedConversationsRecommendationGenerating: (state, action) => {
    if (state.guidedConversationsWidgetData) {
      state.guidedConversationsWidgetData.recommendationGenerating = action.payload;
    }
  },
  updateRecurrentDeleteOptionsSelectedValueForGuidedConversationsWidget: (state, action) => {
    if (state.guidedConversationsWidgetData?.guidesData?.applicableActions) {
      const deleteAction = state.guidedConversationsWidgetData.guidesData.applicableActions.find(
        actionItem => actionItem.uId === guidedConversationConstants.GuideActions.DELETE_MEETING
      );
      if (deleteAction) {
        Object.assign(deleteAction, action.payload);
      }
    }
  }
}

export default guidedConversationsWidgetReducers;